import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import { StoreProvider } from "easy-peasy";
import { store, WaitForStateRehydration } from "./store/index.js";

import { initDatadog } from './services/datadog';
import App from './App';

import './index.scss';
import { ToastProvider } from './components/widgets/toast/ToastProvider.jsx';
import { useToast } from './hooks/useToast.jsx';
import ScrollToTop from './components/widgets/ScrollToTop.jsx';

initDatadog();

const root = createRoot(document.getElementById('root'));
root.render(
    <StoreProvider store={store}>
        <WaitForStateRehydration >
            <ToastProvider>
                <BrowserRouter>
                    <App />
                    <ScrollToTop />
                </BrowserRouter>
            </ToastProvider>
        </WaitForStateRehydration>
    </StoreProvider>
);

export { ToastProvider, useToast };
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
